import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { canonicalOrderingUrl } from "./utils/canonicalHost";
import "./App.css";

const canonicalUrl = canonicalOrderingUrl(window.location.href);

if (canonicalUrl) {
  // Payment providers only accept the production domain (see canonicalHost).
  window.location.replace(canonicalUrl);
} else {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <CookiesProvider>
      <Router>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Router>
    </CookiesProvider>,
  );

  reportWebVitals();
}
